import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { PRODUCT_LINE_FRAGMENT } from 'graphql/fragments/product-line';
import { PRODUCT_LINE_PRODUCT_FRAGMENT } from 'graphql/fragments/product-line-product';
import { Query as RootQuery } from 'graphql/models/generated';

export const PRODUCT_POSITION_BOM_ITEMS_QUERY = gql`
  query GetBomItemsWithParentLine(
    $documentVersion: DocumentVersionInput!
  ) {
    quotes {
      quote(documentVersion: $documentVersion) {
        lines {
          ...ProductLineFragment
          ...ProductLineProductFragment
          ... on ProductLine {
            parentLine {
              id
            }
            isSubLine
            priceCalculation {
              totalPrice
            }
          }
        }
      }
    }
  }
  ${PRODUCT_LINE_FRAGMENT}
  ${PRODUCT_LINE_PRODUCT_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class ProductPositionBomItemsQuery extends Query<RootQuery> {
  document = PRODUCT_POSITION_BOM_ITEMS_QUERY;
}
